import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Topic } from 'src/app/libs/proto/forum_pb';

@Injectable({
  providedIn: 'root'
})
export class TopicConversionService {
  constructor(){}

  ToStorage(req: Topic){
    const w = new BinaryWriter();
    Topic.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (topic: Topic, errorConvert: any) => void) {
    try {
      callback( Topic.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
  ToStorages(topic: Topic[]) {
    const rets = new Array<Uint8Array | number[]>();

    topic.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (topic: Topic[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Topic>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Topic.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }

}
